import { Field } from '@tilework/opus';

import {CartQuery as SourceCartQuery} from 'SourceQuery/Cart.query';
import {CartItemProduct} from 'SourceQuery/Cart.type';

import ProductListQuery from './ProductList.query';

/** @namespace Steinkrueger/Query/Cart/Query */
export class CartQuery extends SourceCartQuery {
    _getCartItemProduct(): Field<'product', CartItemProduct> {
        return new Field<'product', CartItemProduct>('product')
            .addFieldList(ProductListQuery._getUpdatedCartProductInterfaceFields());
    }
}

export default new CartQuery();
